module.exports = __webpack_public_path__ + "img/sadGeoCat.56610ee1.svg";